import { memo } from "react";

import AccountRecoveryDialog from "./AccountRecoveryDialog";
import LoginDialog from "./LoginDialog";
import PasswordRecoveryDialog from "./PasswordRecoveryDialog";
import RegisterDialog from "./RegisterDialog";
import RegisterSuccessDialog from "./RegisterSuccessDialog";

const Dialogs = () => (
  <>
    <AccountRecoveryDialog />
    <LoginDialog />
    <PasswordRecoveryDialog />
    <RegisterDialog />
    <RegisterSuccessDialog />
  </>
);

export default memo(Dialogs);
